import { useLocation } from "react-router-dom";

import { type AgenticLogicSurface } from "@src/features/ai/pages/agentic-logic/surface/surface";
import {
  type AgenticLogicView,
  resolveAgenticLogicView,
} from "@src/features/ai/pages/agentic-logic/surface/ruleViewParams";
import { useActiveAgenticLogicSurface } from "@src/features/ai/pages/agentic-logic/surface/useActiveAgenticLogicSurface";
import {
  DEFAULT_RULE_DETAIL_TAB,
  isRuleDetailTabKey,
  RULE_DETAIL_TAB_PARAM,
  type RuleDetailTabKey,
} from "@src/features/ai/pages/agentic-logic/workspace/ruleDetailTabs";

/**
 * The registered surface, the view it is showing, and the rule tab in the URL,
 * for consumers OUTSIDE the page tree (the chat rail and its asks). Each is
 * read through the surface's own param names, since an embedded surface
 * namespaces its params away from the host's query string. The tab is the
 * requested one, or the default when absent or unknown.
 */
export const useActiveAgenticLogicView = (): {
  surface: AgenticLogicSurface | null;
  view: AgenticLogicView;
  tab: RuleDetailTabKey;
} => {
  const params = new URLSearchParams(useLocation().search);
  const surface = useActiveAgenticLogicSurface();
  const requestedTab = params.get(surface?.tabParam ?? RULE_DETAIL_TAB_PARAM);
  return {
    surface,
    view: resolveAgenticLogicView(
      params,
      surface?.ruleParam,
      surface?.sessionParam
    ),
    tab: isRuleDetailTabKey(requestedTab)
      ? requestedTab
      : DEFAULT_RULE_DETAIL_TAB,
  };
};
